import { NotLoggedInGuard } from './not-logged-in.guard';

export const guards = [NotLoggedInGuard];

export * from './not-logged-in.guard';
